import * as React from 'react';
import { st, classes } from './AvatarGroup.st.css';
import { Avatar, AvatarSize } from '../Avatar';
import { AvatarGroupTextButton } from './AvatarGroupTextButton';
import { TextButton } from '../TextButton';
import {
  AvatarGroupDefaultProps,
  AvatarGroupItem,
  AvatarGroupProps,
  AvatarGroupSize,
} from './types';
import { AvatarGroupBase } from './AvatarGroup.base';
import { DATA_HOOKS } from './constants';
/** The Avatar group is made up of a group of avatars and an optional text link. Content in text link can be customized to the product's intent. */
export class AvatarGroup extends React.Component<AvatarGroupProps> {
  static displayName = 'AvatarGroup';
  static defaultProps: AvatarGroupDefaultProps = {
    items: [],
    maxAmount: 5,
    size: AvatarGroupSize.medium,
    showHiddenAvatarCount: false,
  };
  static TextButton = AvatarGroupTextButton;

  getTextButton = () => {
    const { children } = this.props;
    const textButton = React.Children.toArray(children).find(
      (child) =>
        React.isValidElement(child) &&
        (child.type === TextButton || child.type === AvatarGroupTextButton),
    ) as React.ReactElement;
    if (textButton) {
      return React.cloneElement(textButton, {
        className: `${textButton.props.className || ''} ${classes.textButton}`,
        'data-hook': DATA_HOOKS.textButton,
      });
    }

    return undefined;
  };

  renderAvatar = (renderProps: AvatarGroupItem) => {
    return (
      <Avatar
        size={AvatarSize[this.props.size] || AvatarSize.medium}
        className={classes.avatar}
        {...renderProps}
      />
    );
  };

  render() {
    const { items, size, maxAmount, className, showHiddenAvatarCount } =
      this.props;

    const textButton = this.getTextButton();

    return (
      <div
        className={st(classes.root, { size }, className)}
        data-hook={this.props['data-hook']}
      >
        <AvatarGroupBase
          items={items}
          className={classes.avatars}
          renderHiddenAvatarCount={
            showHiddenAvatarCount ? this.renderAvatar : undefined
          }
          avatarContainerClassName={classes.avatarContainer}
          maxAmount={maxAmount}
          renderAvatar={this.renderAvatar}
        />
        {textButton ? (
          <div className={classes.textButtonContainer}>{textButton}</div>
        ) : null}
      </div>
    );
  }
}
